import { StyleSheet } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { typography } from '../../shared/theme/typography';
import { ticketColors } from '../../shared/theme/ticketColors'
import { ticketSurfaces } from '../../shared/ticket/ticketSurfaces.styles';

export const customersScreenStyles = StyleSheet.create({
  container: {
    ...ticketSurfaces.screen,
    paddingHorizontal: spacing.lg,
    paddingTop: spacing.lg,
  },
  containerCompact: {
    paddingHorizontal: spacing.md,
    paddingTop: spacing.md,
  },
  listFlex: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },
  listContentEmpty: {
    flexGrow: 1,
    justifyContent: 'center',
  },
  listContent: {
    paddingBottom: spacing.xxl,
  },
  wideScrollContent: {
    paddingBottom: spacing.xxl,
  },
  /** Stack de PaperSheets (header + KPIs + alert + lista). */
  stack: {
    gap: 10,
  },
  /** PaperSheet que envuelve la tabla de clientes + paginación. */
  listSheet: {
    overflow: 'hidden',
  },
});
